import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import IntlMessages from '../util/IntlMessages'
import {
  Card,
  Button,
  Input,
  Row,
  Col,
  Form,
  Collapse,
  Modal,
  Divider,
  Checkbox,
  DatePicker,
  Select,
  Switch,
  Table,
  message,
  Spin,
  Space
} from 'antd'
import {
  CloseOutlined,
  DeleteOutlined,
  EditOutlined,
  AccountBookFilled
} from '@ant-design/icons'
import { Tabs } from 'antd'
import ds from '../Services/DataServices'
import moment from 'moment'
import {
  loadData,
  notAllowMsgCheck,
  checkRightspermissions,
  isEmptyObject,
  isEmailValid
} from '../appRedux/actions'
import { useDispatch, useSelector } from 'react-redux'
import {
  setCommonConfigs,
  loadCustomerAddEditModalShow
} from '../appRedux/actions/CommonData'
import { BEHAVIOUR_TYPE } from '../Services/DataServices'
import { CUSTOMER } from '../constants/Pages'
import { checkIsWeb } from '../appRedux/actions/MobAppFn'
import CustomScrollbars from '../util/CustomScrollbars'
import NotAllowedComponent from './NotAllowedComponent'
const genderData = [
  {
    key: 'm',
    name: 'Male'
  },
  {
    key: 'f',
    name: 'Female'
  },
  {
    key: 'b',
    name: 'Non Binary'
  }
]

const AddEditCustomerModal = props => {
  // const { allowAdd, allowUpdate } = props;
  const getCustomerSId = props.id && props.id != '' ? props.id : false
  const dispatch = useDispatch()
  const [form] = Form.useForm()
  const { TabPane } = Tabs
  const { TextArea } = Input
  const { Option } = Select
  const history = useHistory()

  // const loadCommonSettings = useSelector(
  //   ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  // );

  const getReduxCustomerModalShow = useSelector(
    ({ commonConfigs }) => commonConfigs.customersAddEditModalShow
  )
  const loadDataRedux = useSelector(({ settings }) => settings.loadData)
  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )
  const isOnline = useSelector(({ commonConfigs }) => commonConfigs.isOnline)

  const [confirmLoading, setConfirmLoading] = useState(true)
  const [isAddressDifferent, setisAddressDifferent] = useState(false)
  const [isLoyaltySubscribed, setIsLoyaltySubscribed] = useState(true)
  const [getIsEditMode, setIsEditMode] = useState(false)
  const [getCountryData, setgetCountryData] = useState([{ id: 0, label: '' }])
  const [getGroupData, setGroupData] = useState([{ id: '', label: '' }])
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [getCurrData, setCurrData] = useState({
    currencyCode: '',
    currencySymbol: ''
  })

  useEffect(() => {
    if (
      !window.location.pathname.toLocaleLowerCase().includes('/mainsale') &&
      !window.location.pathname.toLocaleLowerCase().includes('/salehistory')
    ) {
      dispatch(setCommonConfigs(CUSTOMER))
    }
    form.setFieldsValue({ customerLoyalty: false })
    if (isOnline) {
      getCountryAndCusGroups()
    }
  }, [])

  useEffect(() => {
    if (getCustomerSId) {
      setIsEditMode(true)
      setConfirmLoading(true)
      getDataForEdit(getCustomerSId)
    } else {
      setIsEditMode(false)
      setConfirmLoading(false)
      // form.setFieldsValue({ customerGroup: "0" });
    }
  }, [getCustomerSId])

  //for common data -> store currency
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      const commonData = getReduxCommonSetting
      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}
      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        setCurrData(currencyData)
      }
      // rights && permissions
      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData)
        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)
          setAccessLoading(false)
        } else {
          toInitialState()
          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])

  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }
    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }
    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }
    if (rpData.create) {
      setIsDisableCreate(false)
    } else {
      setIsDisableCreate(true)
    }
    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }
    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }
  }

  function toInitialState () {
    setRights([])
    setPermissions([])
    setIsAllowRead(false)
    setIsDisableCreate(true)
    setIsDisableUpdate(true)
    setIsDisableDelete(true)
    setAccessLoading(true)
  }

  async function getDataForEdit (id) {
    const createReq = ds.getDataForCustomerEdit(
      { _CustomerSId: id },
      BEHAVIOUR_TYPE.GET
    )
    await createReq
      .then(data => {
        // setvisible(true);
        // setCustomerSId(value);
        if (data) {
          setisAddressDifferent(data.isPhysicalAddress)
          setIsLoyaltySubscribed(data.isLoyaltySubscribe)
          form.setFieldsValue({
            firstNameText: data.customerFirstName,
            lastName: data.customerLastName,
            emailText: data.customerEmail,
            contactNumberTxt: data.contactNumber,
            customerCode: data.customerCode,
            companyName: data.companyName,
            contactNumberType: data.contactNumberType.toString(),
            customerGroup: data.customerGroupId
              ? data.customerGroupId.toString()
              : '0',
            dob: data.dateOfBirth ? moment(data.dateOfBirth) : '',
            streetText: data.postalAddress,
            streetContText: data.postalAddress2,
            subrubText: data.subRub1,
            city: data.city,
            postalCode: data.postalCode,
            state: data.state,
            country:
              parseInt(data.country) == 0
                ? 'Not Selected'
                : parseInt(data.country),
            gender: data.gender.toLowerCase(),
            website: data.website,
            twitter: data.twitter,
            note: data.note,
            phyStreetText: data.permanentPostalAddress
              ? data.permanentPostalAddress
              : data.postalAddress,
            phyStreetContText: data.permanentPostalAddress2
              ? data.permanentPostalAddress2
              : data.postalAddress2,
            phySubrubText: data.permanentSubRub1,
            phyCity: data.permanentCity,
            phyState: data.permanentState,
            phyPostalCode: data.permanentPostalCode,
            phyCountry:
              parseInt(data.permanentCountry) == 0
                ? 'Not Selected'
                : parseInt(data.permanentCountry)
          })
        }
        setConfirmLoading(false)
      })
      .catch(e => {
        notAllowMsgCheck(e)
        setConfirmLoading(false)
        message.error('Some thing went wrong')
      })
  }

  async function getCountryAndCusGroups () {
    const createReq = ds.getCountries()
    await createReq
      .then(res => {
        setgetCountryData(res)
      })
      .then(async () => {
        const groupBody = {
          IsAll: true
        }
        await ds.listCustomerGroup(groupBody, BEHAVIOUR_TYPE.GET).then(res => {
          let array = res.map((data, index) => {
            return {
              id: data._CustomerSId.includes('&')
                ? data._CustomerSId.substring(0, data._CustomerSId.indexOf('&'))
                : data._CustomerSId,
              label: data.customerGroupName
            }
          })
          setGroupData(array)
        })
      })
      .catch(error => {
        notAllowMsgCheck(error)
        // message.error("Some thing went wrong");
      })
  }

  const handleCancel = () => {
    if (getIsEditMode) setIsEditMode(false)
    if (isAddressDifferent) setisAddressDifferent(false)
    setConfirmLoading(false)

    dispatch(loadCustomerAddEditModalShow(false))
    // setvisible(false);
    form.resetFields()
  }

  const handleOk = values => {
    form.resetFields()
    setConfirmLoading(true)
    ds.addCustomer(
      {
        BehaviorName: parseInt(1),
        CustomerFirstName: values.firstNameText,
        IsDifferentPhyscialAddress: isAddressDifferent,
        IsLoyaltyEnabled: isLoyaltySubscribed,
        CustomerLastName: values.lastName,
        CustomerEmail: values.emailText,
        ContactNumber: values.contactNumberTxt,
        ContactNumberType: parseInt(values.contactNumberType),
        CustomerGroupId: values.customerGroup,
        PostalAddres: values.streetText,
        PostalAddres2: values.streetContText,
        SubRub: values.subrubText,
        City: values.city,
        PostalCode: values.postalCode,
        PostalState: values.state,
        country: values.country,
        CustomerCode: values.customerCode ? values.customerCode : '',
        CompanyName: values.companyName,
        DateOfBirth: values.dob,
        Gender: values.gender,
        WebSite: values.website,
        Twitter: values.twitter,
        Note: values.note,
        PPostalAddres: values.phyStreetText
          ? values.phyStreetText
          : values.streetText,
        PPostalAddres2: values.phyStreetContText
          ? values.phyStreetContText
          : values.streetContText,
        PSubRub1: values.phySubrubText
          ? values.phySubrubText
          : values.subrubText,
        PCity: values.phyCity ? values.phyCity : values.city,
        PPostalCode: values.phyPostalCode
          ? values.phyPostalCode
          : values.postalCode,
        PermanentPostalState: values.phyState ? values.phyState : values.state,
        PCountry: values.phyCountry ? values.phyCountry : values.country
      },
      BEHAVIOUR_TYPE.POST
    )
      .then(res => {
        if (res == true) {
          message.success('Customer Created...')
          dispatch(loadData(!loadDataRedux))
        } else if (res == false) {
          message.warn('Something went wrong...')
        }
        setConfirmLoading(false)
        // setvisible(false);
        dispatch(loadCustomerAddEditModalShow(false))
        history.push(`/Dashboard/customers/addcustomer`)
      })
      .catch(error => {
        notAllowMsgCheck(error)
        dispatch(loadCustomerAddEditModalShow(false))
        message.error('Unable to create customer')
      })
  }

  const submitEdit = values => {
    setConfirmLoading(true)
    form.resetFields()

    ds.addCustomer(
      {
        BehaviorName: parseInt(3),
        CustomerSId: getCustomerSId,
        IsDifferentPhyscialAddress: isAddressDifferent,
        IsLoyaltyEnabled: isLoyaltySubscribed,
        CustomerFirstName: values.firstNameText,
        CustomerLastName: values.lastName,
        CustomerEmail: values.emailText,
        ContactNumber: values.contactNumberTxt,
        ContactNumberType: parseInt(values.contactNumberType),
        //CustomerGroupId: ripSId(values.customerGroup),
        CustomerGroupId: values.customerGroup,
        PostalAddres: values.streetText,
        PostalAddres2: values.streetContText,
        SubRub: values.subrubText,
        City: values.city,
        PostalCode: values.postalCode,
        PostalState: values.state,
        country: values.country != 'Not Selected' ? values.country : 0,
        CustomerCode: values.customerCode ? values.customerCode : '',
        CompanyName: values.companyName,
        DateOfBirth: values.dob,
        Gender: values.gender,
        WebSite: values.website,
        Twitter: values.twitter,
        Note: values.note,
        PPostalAddres: values.phyStreetText ? values.phyStreetText : '',
        PPostalAddres2: values.phyStreetContText
          ? values.phyStreetContText
          : '',
        PSubRub1: values.phySubrubText ? values.phySubrubText : '',
        PCity: values.phyCity ? values.phyCity : '',
        PPostalCode: values.phyPostalCode ? values.phyPostalCode : '',
        PermanentPostalState: values.phyState ? values.phyState : '',
        PCountry: values.phyCountry != 'Not Selected' ? values.phyCountry : 0
      },
      BEHAVIOUR_TYPE.UPDATE
    )
      .then(res => {
        message.success('Customer Updated')
        setConfirmLoading(false)
        dispatch(loadCustomerAddEditModalShow(false))
        // setvisible(false);
        setisAddressDifferent(false)
        form.resetFields()
        dispatch(loadData(!loadDataRedux))
        setIsEditMode(false)
      })
      .catch(error => {
        notAllowMsgCheck(error)
        message.error('Unable to update customer')
        setConfirmLoading(false)
        // setvisible(false);
        dispatch(loadCustomerAddEditModalShow(false))
        setisAddressDifferent(false)
        form.resetFields()
        setIsEditMode(false)
      })
  }

  function callback (key) {}

  const ifPhsycialAddressDifferent = e => {
    if (e.target.checked) setisAddressDifferent(true)
    else setisAddressDifferent(false)
  }

  return getIsAllowRead ? (
    <Modal
      className='EditCustomer-modal'
      title={
        getIsEditMode ? (
          <IntlMessages id='customer.addCustomer.UpdateDialogTitle' />
        ) : (
          <IntlMessages id='customer.addCustomer.addDialogTitle' />
        )
      }
      visible={getReduxCustomerModalShow}
      okText={<IntlMessages id='common.resource.submit' />}
      cancelText={<IntlMessages id='common.resource.cancel' />}
      cancelButtonProps={{ className: 'dk-btn-cancel' }}
      confirmLoading={confirmLoading}
      onCancel={handleCancel}
      width={700}
      centered={true}
      onOk={() => {
        form
          .validateFields()
          .then(values => {
            if (getIsEditMode) {
              if (getIsDisableUpdate)
                message.warn('You do not have permission to perform this', 5)
              else submitEdit(values)
            } else {
              if (getIsDisableCreate)
                message.warn('You do not have permission to perform this', 5)
              else handleOk(values)
            }
            // getIsEditMode ? submitEdit(values) : handleOk(values);
          })
          .catch(info => {})
      }}
    >
      <Spin
        tip={<IntlMessages id='sell.cashlisting.cashloading' />}
        spinning={confirmLoading}
        size='large'
      >
        <CustomScrollbars className='gx-layout-sider-scrollbar msHeight'>
          <Form
            form={form}
            name='addCustomerGroup'
            initialValues={{
              modifier: 'public',
              contactNumberType: '2',
              customerGroup: '0'
            }}
          >
            <Tabs defaultActiveKey='1' onChange={callback}>
              <TabPane
                tab={<IntlMessages id='customer.addCustomer.contactTab' />}
                key='1'
              >
                <Row>
                  <Col lg={12} md={12} sm={24} xs={24}>
                    <Form.Item
                      className='row-col-100'
                      name={'firstNameText'}
                      label={
                        <IntlMessages id='customer.addCustomer.customerFirstName' />
                      }
                      rules={[
                        {
                          required: true,
                          message: (
                            <IntlMessages id='customer.addCustomerValidation.required' />
                          )
                        }
                      ]}
                    >
                      <Input maxLength={30} size='large' />
                    </Form.Item>
                  </Col>

                  <Col lg={12} md={12} sm={24} xs={24}>
                    <Form.Item
                      className='row-col-100'
                      name={'emailText'}
                      label={<IntlMessages id='customer.addCustomer.email' />}
                      rules={[
                        {
                          required: true,
                          message: (
                            <IntlMessages id='customer.addCustomerValidation.required' />
                          )
                        },
                        {
                          validator: isEmailValid
                        }
                      ]}
                    >
                      <Input size='large' />
                    </Form.Item>
                  </Col>

                  <Col lg={12} md={12} sm={24} xs={24}>
                    <Form.Item
                      className='row-col-100'
                      name={'customerGroup'}
                      label={
                        <IntlMessages id='customer.addCustomer.customerGroup' />
                      }
                    >
                      <Select
                        size='large'
                        showSearch={checkIsWeb().exist}
                        optionFilterProp='children'
                      >
                        {getGroupData
                          ? getGroupData.map((data, index) => {
                              return (
                                <Select.Option key={index} value={data.id}>
                                  {data.label}
                                </Select.Option>
                              )
                            })
                          : null}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col lg={12} md={12} sm={24} xs={24}>
                    <Form.Item
                      className='row-col-100'
                      name={'lastName'}
                      label={
                        <IntlMessages id='customer.addCustomer.customerLastName' />
                      }
                      rules={[
                        {
                          required: true,
                          message: (
                            <IntlMessages id='customer.addCustomerValidation.required' />
                          )
                        }
                      ]}
                    >
                      <Input maxLength={30} size='large' />
                    </Form.Item>
                  </Col>

                  <Col lg={12} md={12} sm={24} xs={24}>
                    <Input.Group compact>
                      <Form.Item
                        name={'contactNumberType'}
                        label={
                          <IntlMessages id='customer.addCustomer.contactNumber' />
                        }
                        className='phone-type'
                      >
                        <Select size='large'>
                          <Option value='1'>Mobile</Option>
                          <Option value='2'>Phone</Option>
                          <Option value='3'>Fax</Option>
                        </Select>
                      </Form.Item>

                      <Form.Item
                        name={'contactNumberTxt'}
                        label={'      '}
                        rules={[
                          {
                            pattern: /^[0-9+\-() ]*$/,
                            message: 'Please enter a valid contact number.'
                          }
                        ]}
                        className='number-type'
                      >
                        <Input maxLength={20} size='large' />
                      </Form.Item>
                    </Input.Group>
                  </Col>
                </Row>
              </TabPane>

              <TabPane
                tab={<IntlMessages id='customer.addCustomer.detailsTab' />}
                key='2'
              >
                <Row>
                  <strong>
                    <IntlMessages id='customers.addCustomer.postalGroupTitle' />
                  </strong>
                  <Divider />
                </Row>

                <Row>
                  <Col lg={12} md={12} sm={24} xs={24}>
                    <Form.Item
                      className='row-col-100'
                      name={'streetText'}
                      label={
                        <IntlMessages id='customer.addCustomer.customerstreet' />
                      }
                    >
                      <Input maxLength={200} size='large' />
                    </Form.Item>
                  </Col>

                  <Col lg={12} md={12} sm={24} xs={24}>
                    <Form.Item
                      className='row-col-100'
                      name={'subrubText'}
                      label={<IntlMessages id='customer.addCustomer.subrub' />}
                    >
                      <Input maxLength={200} size='large' />
                    </Form.Item>
                  </Col>

                  <Col lg={12} md={12} sm={24} xs={24}>
                    <Form.Item
                      className='row-col-100'
                      name={'postalCode'}
                      label={
                        <IntlMessages id='customer.addCustomer.postalCode' />
                      }
                    >
                      <Input maxLength={50} size='large' />
                    </Form.Item>
                  </Col>

                  <Col lg={12} md={12} sm={24} xs={24}>
                    <Form.Item
                      className='row-col-100'
                      name={'country'}
                      label={<IntlMessages id='customer.addCustomer.country' />}
                    >
                      <Select
                        size='large'
                        showSearch={checkIsWeb().exist}
                        optionFilterProp='children'
                      >
                        {getCountryData &&
                          getCountryData.length > 0 &&
                          getCountryData.map(data => {
                            return (
                              <Select.Option value={data.id}>
                                {data.label}
                              </Select.Option>
                            )
                          })}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col lg={12} md={12} sm={24} xs={24}>
                    <Form.Item
                      className='row-col-100'
                      name={'streetContText'}
                      label={<IntlMessages id='customer.addCustomer.street' />}
                    >
                      <Input maxLength={50} size='large' />
                    </Form.Item>
                  </Col>

                  <Col lg={12} md={12} sm={24} xs={24}>
                    <Form.Item
                      className='row-col-100'
                      name={'city'}
                      label={<IntlMessages id='customer.addCustomer.city' />}
                    >
                      <Input maxLength={50} size='large' />
                    </Form.Item>
                  </Col>

                  <Col lg={12} md={12} sm={24} xs={24}>
                    <Form.Item
                      className='row-col-100'
                      name={'state'}
                      label={<IntlMessages id='customer.addCustomer.state' />}
                    >
                      <Input maxLength={50} size='large' />
                    </Form.Item>
                  </Col>

                  <Col lg={12} md={12} sm={24} xs={24}>
                    <Form.Item name={'isDifferent'}>
                      <Checkbox
                        size='large'
                        onChange={ifPhsycialAddressDifferent}
                        //value={isAddressDifferent}
                        checked={isAddressDifferent}
                      >
                        <IntlMessages id='customer.addCustomer.sameAsPostalAddress' />
                      </Checkbox>
                    </Form.Item>
                  </Col>
                </Row>

                {isAddressDifferent ? (
                  <>
                    <Row>
                      <strong>
                        <IntlMessages id='customers.addCustomer.physcialGroupTitle' />
                      </strong>
                      <Divider />
                    </Row>

                    <Row>
                      <Col lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                          className='row-col-100'
                          name={'phyStreetText'}
                          label={
                            <IntlMessages id='customer.addCustomer.customerstreet' />
                          }
                        >
                          <Input maxLength={50} size='large' />
                        </Form.Item>
                      </Col>

                      <Col lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                          className='row-col-100'
                          name={'phySubrubText'}
                          label={
                            <IntlMessages id='customer.addCustomer.subrub' />
                          }
                        >
                          <Input maxLength={50} size='large' />
                        </Form.Item>
                      </Col>

                      <Col lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                          className='row-col-100'
                          name={'phyPostalCode'}
                          label={
                            <IntlMessages id='customer.addCustomer.postalCode' />
                          }
                        >
                          <Input maxLength={50} size='large' />
                        </Form.Item>
                      </Col>

                      <Col lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                          className='row-col-100'
                          name={'phyCountry'}
                          label={
                            <IntlMessages id='customer.addCustomer.country' />
                          }
                        >
                          <Select
                            size='large'
                            showSearch={checkIsWeb().exist}
                            optionFilterProp='children'
                          >
                            {getCountryData &&
                              getCountryData.length > 0 &&
                              getCountryData.map(data => {
                                return (
                                  <Select.Option value={data.id}>
                                    {data.label}
                                  </Select.Option>
                                )
                              })}
                          </Select>
                        </Form.Item>
                      </Col>

                      <Col lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                          className='row-col-100'
                          name={'phyStreetContText'}
                          label={
                            <IntlMessages id='customer.addCustomer.street' />
                          }
                        >
                          <Input maxLength={50} size='large' />
                        </Form.Item>
                      </Col>

                      <Col lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                          className='row-col-100'
                          name={'phyCity'}
                          label={
                            <IntlMessages id='customer.addCustomer.city' />
                          }
                        >
                          <Input maxLength={50} size='large' />
                        </Form.Item>
                      </Col>

                      <Col lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                          className='row-col-100'
                          name={'phyState'}
                          label={
                            <IntlMessages id='customer.addCustomer.state' />
                          }
                        >
                          <Input maxLength={50} size='large' />
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                ) : (
                  ''
                )}

                <Row className='mt-3'>
                  <strong>
                    <IntlMessages id='customers.addCustomer.additionalInformationGroup' />
                  </strong>
                  <Divider />
                </Row>

                <Row>
                  {/* 
              <Col lg={12} md={12} sm={24} xs={24}>
              <Form.Item className="row-col-100"
                      name={"customerCode"}
                      label={
                        <IntlMessages id="customer.addCustomer.customerCode" />
                      }
                    >
                      <Input maxLength={50} size="large" />
                    </Form.Item>
              </Col> */}

                  <Col lg={12} md={12} sm={24} xs={24}>
                    <Form.Item
                      className='row-col-100'
                      name={'dob'}
                      label={<IntlMessages id='customer.addCustomer.dob' />}
                    >
                      <DatePicker
                        className='w-100'
                        size='large'
                        inputReadOnly={true}
                      />
                    </Form.Item>
                  </Col>

                  <Col lg={12} md={12} sm={24} xs={24}>
                    <Form.Item
                      className='row-col-100'
                      name={'website'}
                      label={<IntlMessages id='customer.addCustomer.website' />}
                    >
                      <Input maxLength={100} size='large' />
                    </Form.Item>
                  </Col>

                  <Col lg={12} md={12} sm={24} xs={24}>
                    <Form.Item
                      className='row-col-100'
                      name={'companyName'}
                      label={
                        <IntlMessages id='customer.addCustomer.companyName' />
                      }
                    >
                      <Input maxLength={100} size='large' />
                    </Form.Item>
                  </Col>

                  <Col lg={12} md={12} sm={24} xs={24}>
                    <Form.Item
                      className='row-col-100'
                      name={'gender'}
                      label={<IntlMessages id='customer.addCustomer.gender' />}
                    >
                      <Select
                        size='large'
                        showSearch={checkIsWeb().exist}
                        optionFilterProp='children'
                      >
                        {genderData.map(data => {
                          return (
                            <Select.Option value={data.key}>
                              {data.name}
                            </Select.Option>
                          )
                        })}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col lg={12} md={12} sm={24} xs={24}>
                    <Form.Item
                      className='row-col-100'
                      name={'twitter'}
                      label={<IntlMessages id='customer.addCustomer.twitter' />}
                    >
                      <Input maxLength={100} size='large' />
                    </Form.Item>
                  </Col>

                  <Col lg={12} md={12} sm={24} xs={24}>
                    <Form.Item
                      className='row-col-100'
                      name={'note'}
                      label={<IntlMessages id='customer.addCustomer.note' />}
                    >
                      <TextArea />
                    </Form.Item>
                  </Col>

                  <Col lg={12} md={12} sm={24} xs={24}>
                    <IntlMessages id='customerz.cus.loyalty' />
                    <Form.Item
                      className='row-col-100'
                      name={'customerLoyalty'}
                      //style={{ marginTop: "55px" }}
                    >
                      <Switch
                        checked={isLoyaltySubscribed}
                        onChange={() =>
                          setIsLoyaltySubscribed(!isLoyaltySubscribed)
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </TabPane>
            </Tabs>
          </Form>
        </CustomScrollbars>
      </Spin>
    </Modal>
  ) : (
    <NotAllowedComponent getAccessLoading={getAccessLoading} textType={1} />
  )
}
export default AddEditCustomerModal
